/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const TITLES = {
  DELETE: "Delete",
  CANCEL: "Cancel",
  DELETE_REALM: "Delete Realm",
};

export const MESSAGES = {
  DELETE_REALM_MESSAGE: "Are you sure you want to delete the Realm ",
  THIS_ACTION_CANNOT_BE_UNDONE: "? This action cannot be undone.",
};
